export default __webpack_public_path__ + "static/media/rocket_anim_16.3c90d219.png";